import { useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Tracer } from '!core/features';
import { selectConfigurationParameterById } from '!core/redux';
import { logoutSlice } from '»components/Auth';
import { getActiveMenuItemSelector, MenuMobile } from '»components/Menus';
import { useCurrentPage, useUserAuthentication } from '»utils/customHooks';

import { Menu } from '../../Menus/Menu';
import { ChildContainerStyled, PaperStyled } from './PrivateView.styles';

export const PrivateView = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const dispatch = useDispatch();

  const inactivityTime = useSelector((state) =>
    selectConfigurationParameterById(state, 'INACTIVITY_TIME'),
  )?.value;
  const activeMenuItem = useSelector(getActiveMenuItemSelector);

  const { isProofPreviewPage } = useCurrentPage();

  const { isUserAuthenticated } = useUserAuthentication();

  let timeout = null;

  const logoutUser = () => {
    dispatch(logoutSlice.actions.logoutRequest({ showAlert: true }));
  };

  const restartTimer = () => {
    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(logoutUser, Number(inactivityTime) * 1000);
  };

  useEffect(() => {
    restartTimer();

    if (isMobile) {
      window.addEventListener('touchstart', restartTimer);
    } else {
      window.addEventListener('mousemove', restartTimer);
      window.addEventListener('mousedown', restartTimer);
    }

    return () => {
      if (timeout) clearTimeout(timeout);

      if (isMobile) {
        window.removeEventListener('touchstart', restartTimer);
      } else {
        window.removeEventListener('mousemove', restartTimer);
        window.removeEventListener('mousedown', restartTimer);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isUserAuthenticated)
    return (
      <Tracer optionId={activeMenuItem}>
        {!isMobile && !isProofPreviewPage && <Menu />}
        <ChildContainerStyled isProofPreviewPage={isProofPreviewPage}>
          {children}
        </ChildContainerStyled>
        {isMobile && !isProofPreviewPage && (
          <PaperStyled elevation={3}>
            <MenuMobile />
          </PaperStyled>
        )}
      </Tracer>
    );

  return null;
};

PrivateView.propTypes = {
  optionId: PropTypes.string,
  children: PropTypes.element,
};
